import type { TMessages } from '@/types/TMessages'

export const messages = { yesterday: 'Вчера', today: 'Сегодня' } satisfies TMessages
